import { render, staticRenderFns } from "./add-data.vue?vue&type=template&id=059dd5fd&scoped=true"
import script from "./add-data.vue?vue&type=script&lang=ts"
export * from "./add-data.vue?vue&type=script&lang=ts"
import style0 from "./add-data.vue?vue&type=style&index=0&id=059dd5fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059dd5fd",
  null
  
)

export default component.exports